import { render, staticRenderFns } from "./case-item.vue?vue&type=template&id=427b092f&scoped=true&"
import script from "./case-item.vue?vue&type=script&lang=ts&"
export * from "./case-item.vue?vue&type=script&lang=ts&"
import style0 from "./case-item.vue?vue&type=style&index=0&id=427b092f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b092f",
  null
  
)

export default component.exports